interface IElement {
	uid: string;
}
export default IElement;

export const VIElement = {
	uid: 'string',
};
